module.exports = __webpack_public_path__ + "static/img/bg0.5c9610d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg0.png
// module id = zU7D
// module chunks = 0